export const state = {
    answers: {},
}

export const mutations = {
    setAnswers(state, payload) {
        state.answers = payload;
    },

    setAnswerAlternatives(state, payload) {
        state.answers.form.questions[payload.index].answerAlternatives = [payload.id];
    },

    setAnswerAlternativesSelect(state, payload) {
        state.answers.form.questions[payload.index].answerAlternatives = payload.alternatives;
    },

    addOrRemoveAnswerAlternative(state, payload) {
        if (state.answers.form.questions[payload.index].answerAlternatives.indexOf(payload.id) < 0) {
            state.answers.form.questions[payload.index].answerAlternatives.push(payload.id);
        } else {
            state.answers.form.questions[payload.index].answerAlternatives = state.answers.form.questions[payload.index].answerAlternatives.filter(value => value !== payload.id)
        }
    },

    setAnswer(state, payload) {
        state.answers.form.questions[payload.index].answer = payload.answer;

        if (payload.fileURL) state.answers.form.questions[payload.index].fileURL = payload.fileURL;
    }
}

export const actions = {
    getAnswer(context, index) {
        return state.answers[index] ? state.answers[index].answer : '';
    }
}
